import styled from 'styled-components'

import SpotLogo from '~/graphics/spot.png'

export const Logo = styled.img.attrs(() => ({
  src: SpotLogo,
  alt: 'Spot Insurance',
}))`
  display: block;
  width: 40 px;
  height: 20px;
  margin: 10px 0 5px 0;
  flex-shrink: 0;
`
export default Logo
